import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import polyfill from "abortcontroller-polyfill/dist/cjs-ponyfill";

export {};

(async () => {
  if (typeof window !== "undefined") {
    // Manually add the missing methods if they don't exist
    if (!(AbortSignal as any).timeout) {
      (AbortSignal as any).timeout = polyfill.AbortSignal.timeout;
    }

    if (!(AbortSignal as any).any) {
      (AbortSignal as any).any =
        polyfill?.AbortSignal?.any ||
        function () {
          return "any" in AbortSignal;
        };
    }
  }
})();
